import axios from "axios";
import env from "../../constants/apiConst";

export const __Products = async (token, body, page) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: body || ""
  };

  const res = await axios(`${env.PRODUCTS_GET}?page=${page || 1}`, options);
  return res;
};

export const __ProductsAll = async (token) => {
  const options = {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
  };

  const res = await axios(`${env.PRODUCTS_ALL}`, options);
  return res;
};

export const __ShowProducts = async (token, page, body) => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: body || ""
  };

  const res = await axios(`${env.PRODUCTS_GET}?page=${page}`, options);
  return res;
};
